import React from 'react';
import WidgetContext from './WidgetContext';

export default function withWidget(WrappedComponent) {
  return (props) => {
    return (
      <WidgetContext.Consumer>
        {({ updateWidget, widget }) => (
          <WrappedComponent widget={widget} updateWidget={updateWidget} {...props} />
        )}
      </WidgetContext.Consumer>
    );
  };
}
